module.exports = __webpack_public_path__ + "img/svg/result-loser-trophy.2c8580dd845848c28c37992d654954b6.svg";